import { render } from "./Distributors.vue?vue&type=template&id=aeeab120&scoped=true"
import script from "./Distributors.vue?vue&type=script&lang=js"
export * from "./Distributors.vue?vue&type=script&lang=js"

import "./Distributors.vue?vue&type=style&index=0&id=aeeab120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeeab120"]])

export default __exports__